/* src/app/layout/card-view-layout/card-view-system-card/card-view-system-card.component.css */
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 20px;
  width: 100%;
  height: 150px;
  display: inline-block;
  cursor: pointer;
  background-color: white;
  color: Black;
}
@media screen and (max-width: 1450px) {
  .card {
    width: 280px;
  }
}
@media screen and (max-device-width: 500px) {
  .card {
    width: 100%;
  }
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.container {
  padding: 2px 16px;
}
.content {
  display: block;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  max-height: 3.6em;
  height: 3.6em;
  line-height: 1.8em;
}
.card-container {
  display: relative;
  max-height: 100%;
}
.actions {
  position: absolute;
  display: block;
  align-content: right;
  width: 300px;
  height: 30px;
  bottom: 10px;
  right: 20px;
}
.action {
  display: block;
  float: right;
  margin-left: 10px;
  opacity: 1;
  transition: 0.3s;
  color: var(--red);
}
.status-ok {
  display: block;
  float: right;
  margin-left: 10px;
  opacity: 1;
  transition: 0.3s;
  color: green;
}
@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
.status-error {
  display: block;
  float: right;
  margin-left: 10px;
  opacity: 1;
  transition: 0.3s;
  color: var(--red);
  animation: blink 1s linear infinite;
}
.status-unknown {
  display: block;
  float: right;
  margin-left: 10px;
  opacity: 1;
  transition: 0.3s;
  color: #bdbdbd;
}
.shell-button {
  position: absolute;
  left: 10px;
  bottom: 10px;
  background-color: transparent;
  color: var(--orange);
  fill: var(--orange);
  border: none;
  cursor: pointer;
}
.title {
  font-size: 16pt;
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}
.location {
  font-size: 12pt;
  color: #666;
  display: block;
  margin-bottom: 10px;
}
.site {
  font-size: 12pt;
  color: #666;
  display: block;
}
.thumb {
  font-size: 12pt;
  padding-bottom: 5px;
  padding-right: 10px;
}
.tumb-number {
  color: var(--orange);
  font-weight: bold;
  font-size: 12pt;
  padding-bottom: 5px;
  padding-right: 5px;
}
.red {
  color: black;
  transition: 0.3s;
}
.red:hover {
  opacity: 1 !important;
  color: red;
}
.action:hover {
  opacity: 1;
}
.add-icon {
  text-align: center;
  font-size: 55pt;
}
.add-card {
  opacity: 0.4;
  transition: 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.add-card:hover {
  opacity: 1;
}
.clear {
  display: absolute;
  float: right;
  margin-left: 10px;
  opacity: 0.4;
  transition: 0.3s;
}
.clear:hover {
  opacity: 1;
}
/*# sourceMappingURL=card-view-system-card.component.css.map */
